import moment from 'moment';
import download from 'downloadjs';
import { getBrowserLanguage } from './util';

// Carries a ?tenant=<code> override (used to test via ALB DNS before custom
// DNS is configured) from the page URL onto our own API calls, since the
// backend only sees the query string of the request it actually receives.
function withTenantOverride(url) {
    const tenant = new URLSearchParams(window.location.search).get('tenant');
    if (!tenant) {
        return url;
    }
    return `${url}${url.includes('?') ? '&' : '?'}tenant=${encodeURIComponent(tenant)}`;
}

async function getTheme() {
    const result = await fetch(withTenantOverride('/api/theme'));
    const json = await result.json();
    return json;
}

function getReceipts({
    departureDate,
    flightNumber,
    seatNumber,
    invoiceId,
    lastDigits,
    selectedPaymentMethod,
}) {
    const timeFormatted = moment(departureDate).format('YYYY-MM-DD');
    return new Promise(async (resolve, reject) => {
        grecaptcha.ready(function () {
            grecaptcha.execute(window.RECAPTCHA_SITE_KEY, { action: 'homepage' }).then(async (recaptcha_token) => {
                const body = {
                    recaptcha_token,
                    order_flight_number: flightNumber,
                    order_date: timeFormatted,
                    card_last_digits: lastDigits,
                    selected_payment_method: selectedPaymentMethod,
                    order_invoice_id: invoiceId,
                    order_seat_number: seatNumber,
                };
                const result = await fetch(withTenantOverride('/api/order/searchOrder'), {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    method: 'POST',
                    body: JSON.stringify(body),
                });
                const json = await result.json();
                resolve(json && json.data);
            }).catch(reject);
        });
    })
}

function downloadReceipt(orderId) {
    return new Promise(async (resolve, reject) => {
        grecaptcha.ready(function () {
            grecaptcha.execute(window.RECAPTCHA_SITE_KEY, { action: 'homepage' }).then(async (recaptcha_token) => {
                const result = await fetch(withTenantOverride('/api/receipt/buildReceipt'), {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    method: 'POST',
                    body: JSON.stringify({
                        recaptcha_token,
                        order_id: orderId,
                        user_language: getBrowserLanguage(),
                    }),
                });
                if (result.status !== 200) {
                    return reject();
                }
                const blob = await result.blob();
                download(blob, orderId);
            }).catch(reject);
        });
    });
}

export {
    getTheme,
    getReceipts,
    downloadReceipt,
}